var exports = {
  "B": "AuthCardContainer.module__inertOverlay___Wjl0VW",
};

module.exports = exports;
